module.exports = __webpack_public_path__ + "static/media/Home IKI is an IoT provider company focus on Smart Meter & Sensor IoT.260c4f27.png";